<template>
  <wt-box class="wt-button" :class="{'radius':radius,'disable':disable}">
    <!-- <mu-ripple color="black" v-if="ripple">
      <slot />
    </mu-ripple>
    <slot v-else/>-->
     <slot />
  </wt-box>
</template>

<script>
export default {
  name: 'wt-button',
  props: {
    radius: {
      type: Boolean,
      default: true
    },
    disable: {
      type: Boolean,
      default: false
    },
    ripple: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.wt-button {
  padding: 0.3rem;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  &.disable{
    background-color:#ccc!important;
  }
}
.wt-primary {
  transition: all 0.3s ease;
}
</style>
<style lang="less">
.wt-button {
  color: #fff;
  &.radius {
    border-radius: 1rem;
    .mu-ripple-wrapper {
      border-radius: 1rem;
    }
  }
}
</style>
